module.exports = __webpack_public_path__ + "img/sushe.b29269b0.png";